import { SET_IS_OPEN_TABLE_SETTINGS_MODAL } from '../actionTypes';
import { tableSettingsActions } from '../reducer';

export default (isOpen) =>
    tableSettingsActions[SET_IS_OPEN_TABLE_SETTINGS_MODAL](isOpen);
